import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-order-place',
  templateUrl: './icon-order-place.component.html',
  styleUrls: ['./icon-order-place.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconOrderPlaceComponent {}
